import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {IAppValidator} from './validator';
import parseISO from 'date-fns/parseISO';
import differenceInYears from 'date-fns/differenceInYears';
import parse from 'date-fns/parse';

const dateDifferenceFn: any = {
  Y: differenceInYears
};

export const minAgeErrorKey = 'minAgeErrorKey';
export const maxAgeErrorKey = 'maxAgeErrorKey';

interface DateConfiguration {
  value: number;
  type: string;
  differenceFn: (dateLeft: Date | number, dateRight: Date | number) => number;
}

export function getDateConfiguration(value: string): DateConfiguration {
  const regex = /(\d*)(\w)/g.exec(value);

  if (regex) {
    return {
      value: parseInt(regex[1], 10),
      type: regex[2],
      differenceFn: dateDifferenceFn[regex[2]]
    };
  }

  return {
    value: 0,
    type: 'Y',
    differenceFn: dateDifferenceFn.Y
  };
}

function getDateValue(value: string | Date): Date {
  return typeof value === 'string' ? parseISO(value) : value;
}

export class MinAgeValidator implements IAppValidator {
  execute(configurationValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const {differenceFn, value} = getDateConfiguration(configurationValue);
      const inputDate = parse(control.value, 'dd/MM/yyyy', new Date());
      const diff = differenceFn(new Date(), inputDate);
      const minAge = value;

      if (minAge > diff) {
          return {[minAgeErrorKey]: `Mínimo ${minAge} anos`};
        }
      return {};
    };
  }
}

export class MaxAgeValidator implements IAppValidator {
  execute(configurationValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const {differenceFn, value} = getDateConfiguration(configurationValue);
      const inputDate = parse(control.value, 'dd/MM/yyyy', new Date());
      const diff = differenceFn(new Date(), inputDate);
      const maxAge = value;

      if (maxAge < diff) {
        return {[maxAgeErrorKey]: `Máximo ${maxAge} anos`};
      }
      return {};
    };
  }
}

export const minAgeValidator = new MinAgeValidator();
export const maxAgeValidator = new MaxAgeValidator();
